"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
import { useEffect, useRef, useState } from "react";
export default function ServicesHero() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const heroRef = useRef<HTMLElement>(null);
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      if (heroRef.current) {
        const rect = heroRef.current.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          setScrollY(window.scrollY);
        }
      }
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const parallaxOffset = scrollY * 0.4;
  return <section id="services-hero" ref={heroRef} className="dark bg-background text-foreground relative flex min-h-[70vh] items-center justify-center overflow-hidden">
      <div className="absolute inset-0 bg-cover bg-center" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541656/img/professional_workspace_bright_bokeh.png)",
      transform: `translateY(${parallaxOffset}px)`,
      transition: "transform 0.1s ease-out"
    }}>
        <div className="absolute inset-0 bg-dark-background/60" />
      </div>

      <div ref={contentRef} className="relative z-10 mx-auto max-w-4xl px-6 py-24 text-center" style={{
      opacity: isVisible ? 1 : 0,
      transform: isVisible ? "translateY(0)" : "translateY(20px)",
      transition: "opacity 150ms ease-out, transform 150ms ease-out"
    }}>
        <h1 className="mb-6 text-5xl font-bold leading-tight tracking-tight text-foreground-dark md:text-6xl lg:text-7xl">
          Administrative Support for ABA & Behavioral Health Providers
        </h1>

        <p className="mb-8 text-lg text-foreground-dark/90 md:text-xl lg:text-2xl">
          Accurate, compliant, and reliable administrative services to support
          your practice
        </p>

        <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
          <Link to="#get-started" className="btn-primary inline-flex items-center justify-center rounded-md bg-primary px-8 py-4 text-base font-semibold text-foreground-primary shadow-medium transition-all duration-fast ease-out hover:-translate-y-0.5 hover:brightness-95 hover:shadow-strong focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring active:translate-y-0 active:brightness-90">
            Request a Consultation
          </Link>

          <Link to="#contact" className="inline-flex items-center justify-center rounded-md border-2 border-white/30 bg-white/10 px-8 py-4 text-base font-semibold text-foreground-dark backdrop-blur-sm transition-all duration-fast ease-out hover:-translate-y-0.5 hover:bg-white/20 hover:shadow-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white active:translate-y-0 active:bg-white/15">
            Contact Us
          </Link>
        </div>
      </div>
    </section>;
}